/*
  File name: initialOrderLetter.js
  Program Description:
  - This script generates the PDF file of the initial order letter.
*/
import republicOfPHLogo from '@/assets/republic-of-the-philippines-logo.jpg'
import npcLogo from '@/assets/npc-logo.jpg'
async function getImageDataUrl (image) {
  const response = await fetch(image)
  const blob = await response.blob()
  const data = await blobToDataURL(blob)
  return data
}

function blobToDataURL (blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = _e => resolve(reader.result)
    reader.onerror = _e => reject(reader.error)
    reader.readAsDataURL(blob)
  })
}
const initialOrderTemplate = async (details) => {
  const RPHLogo = await getImageDataUrl(republicOfPHLogo)
  const NPCLogo = await getImageDataUrl(npcLogo)
  return {
    pageMargins: [72, 190, 72, 72],
    pageSize: 'LEGAL',
    header: () => [
      {
        image: RPHLogo,
        width: 65,
        height: 90,
        absolutePosition: {
          x: 250,
          y: 50
        }
      },
      {
        image: NPCLogo,
        width: 40,
        height: 90,
        absolutePosition: {
          x: 318,
          y: 50
        }
      },
      '\n',
      '\n',
      '\n',
      '\n',
      '\n',
      '\n',
      '\n',
      '\n',
      '\n',
      '\n',
      {
        text: 'Republic of the Philippines',
        alignment: 'center',
        style: ['title']
      },
      {
        text: 'NATIONAL PRIVACY COMMISSION',
        alignment: 'center',
        style: ['bold', 'title']
      },
      {
        alignment: 'center',
        canvas: [
          {
            type: 'line',
            x1: 0,
            y1: 5,
            x2: 550 - 2 * 40,
            y2: 5,
            lineWidth: 3
          }
        ]
      }
    ],
    footer: () => [
      {
        columns: [
          // `Ref No. OP_${details.dbnNumber}`,
          '',
          {
            text: `NPC_DASCO_CMD_ORD-V1.0, R0.0, ${details.date}`,
            alignment: 'right',
            width: '70%'
          }
        ],
        margin: [72, 0, 72, 0],
        fontSize: 9
      },
      {
        canvas: [
          {
            type: 'line',
            x1: 0,
            y1: 3,
            x2: 550 - 2 * 40,
            y2: 3,
            lineWidth: 3
          }
        ],
        margin: [72, 0, 72, 0]
      },
      {
        text: '5th Floor, Philippine International Convention Center, Vicente Sotto Avenue, Pasay City, Metro Manila 1307',
        fontSize: 9.5,
        alignment: 'center',
        margin: [72, 0, 72, 0]
      },
      {
        text: [
          'URL: ',
          {
            text: 'http://privacy.gov.ph',
            decoration: 'underline',
            color: '#09689e'
          },
          ' Email Add: ',
          {
            text: 'info@privacy.gov.ph',
            decoration: 'underline',
            color: '#09689e'
          },
          ' Tel No. 8234-2228'
        ],
        fontSize: 9.5,
        alignment: 'center',
        margin: [72, 0, 72, 0]
      }
    ],
    // to replace static data with values
    content: [
      {
        text: `NPC BN No. ${details.dbnNumber}`,
        style: ['bold']
      },
      {
        text: [
          {
            text: 'In Re: ',
            bold: true
          },
                `Breach Notification Report of ${details.picName}`
        ]
      },
      {
        text: '\n'
      },
      {
        text: 'ORDER',
        style: ['order']
      },
      {
        text: '\n'
      },
      {
        text: 'The Data Privacy Act (DPA) requires prompt notification of the National Privacy Commission (NPC) and affected data subjects when sensitive personal information or other information that may, under the circumstances, be used to enable identity fraud are reasonably believed to have been acquired by an unauthorized person, which may likely give rise to a real risk of serious harm to any affected data subject.',
        alignment: 'justify'
      },
      {
        text: '\n'
      },
      {
        text: `In view of the security incident that was discovered on ${details.formattedDateOfDiscovery}, the breach notification report you submitted to the Commission on ${details.formattedDateOfNotification}, and for purposes of demonstrating compliance with the DPA and existing regulation, further information is required.`,
        alignment: 'justify'
      },
      {
        text: '\n'
      },
      {
        text: [
          {
            text: 'WHEREFORE, ',
            style: ['bold']
          },
          'premises considered, the ',
          {
            text: `${details.picName} `,
            style: ['bold']
          },
          'is ',
          {
            text: 'ORDERED:',
            style: ['bold']
          }
        ]
      },
      {
        text: '\n'
      },
      {
        text: [
          {
            text: 'TO SUBMIT ',
            style: ['bold']
          },
          ' the following documents: '
        ]
      },
      {
        text: '\n'
      },
      {
        ol: details.enabledArr
      },
        `${details.newLines}`,
        {
          text: '\n'
        },
        {
          text: [
            {
              text: `${details.picName}, `,
              style: ['bold']
            },
            'is hereby given a period of ',
            {
              text: `${details.daysString}(${details.days}) ${details.daysText} `,
              style: ['bold']
            },
            'from receipt hereof to submit its compliance through the Data Breach Notification System (',
            {
              text: 'https://dbnms.privacy.gov.ph',
              style: ['link']
            },
            ')'
          ]
        },
        {
          text: '\n'
        },
        {
          text: 'SO ORDERED.',
          style: ['bold']
        },
        {
          text: '\n'
        },
        {
          text: `${details.address}, ${details.date}.`
        },
        {
          text: '\n'
        },
        {
          text: '\n'
        },
        {
          text: 'For the Commission:'
        },
        {
          text: '\n'
        },
        {
          text: `${details.chiefName}`,
          style: ['bold']
        },
        {
          text: 'Chief, Compliance and Monitoring Division'
        },
        {
          text: '\n'
        },
        {
          text: '\n'
        },
        {
          text: 'COPY FURNISHED:',
          style: ['bold']
        },
        {
          text: '\n'
        },
        {
          text: `${details.picName}`,
          style: ['bold']
        },
        {
          text: `${details.email}`
        }
    ],
    styles: {
      title: {
        fontSize: 12
      },
      subtitle: {
        fontSize: 11
      },
      items: {
        fontSize: 9
      },
      bold: {
        bold: true
      },
      italic: {
        italics: true
      },
      underline: {
        decoration: 'underline'
      },
      order: {
        fontSize: 14,
        bold: true,
        alignment: 'center'
      },
      list: {
        margin: [55, 0, 0, 0]
      },
      link: {
        color: '#5d9cd8'
      }
    },
    defaultStyle: {
      columnGap: 8,
      fontSize: 12
    }
  }
}

const formatListOfAttachments = (enabledAttachment, others) => {
  const sectionsOfThePrivacyItems = ['operationsSecurity', 'systemAcquisition', 'accessControl', 'communicationsSecurity', 'physicalAndEnvironmentalSecurity', 'assetManagement', 'cryptography', 'humanResourceSecurity', 'compliance']
  const sectionsOfThePrivacy = []
  const result = []
  let isSectionIncluded = true
  let hasOthers = false
  let listCount = 0

  const sentenceCase = (str) => {
    // eslint-disable-next-line security/detect-unsafe-regex
    return str.replace(/(?<camelCase>[A-Z])/gu, ' $1').replace(/^./u, (s) => s.toUpperCase())
  }

  for (const [key, value] of Object.entries(enabledAttachment)) {
    if (value) {
      listCount += 1
      if (sectionsOfThePrivacyItems.includes(key)) {
        sectionsOfThePrivacy.push(sentenceCase(key))
        if (isSectionIncluded) {
          result.push('Sections of the Privacy Manual pertaining to the following:')
          isSectionIncluded = false
        }
        continue
      }
      if (key === 'othersAttachment') {
        hasOthers = true
        result.push('Others')
        listCount += 1
        continue
      }
      result.push(sentenceCase(key))
    }
  }

  if (sectionsOfThePrivacy.length) {
    const index = result.indexOf('Sections of the Privacy Manual pertaining to the following:')
    result[`${index}`] = [
      'Sections of the Privacy Manual pertaining to the following:',
      {
        ul: sectionsOfThePrivacy
      }
    ]
  }

  if (others && others.length && hasOthers) {
    listCount = listCount + others.length
    result.push(typeof others === 'string' ? { ul: [others] } : { ul: others })
  }

  return { formattedList: result, listCount }
}

const computeNewLines = (maxCount, listCount, adjustmentNL = 24) => {
  if (maxCount > listCount) return ''
  const finalCount = adjustmentNL - (listCount - maxCount)
  if (finalCount < 0) return ''
  return new Array(finalCount).fill('\n').reduce((acc, curr) => acc + curr)
}

export default {
  initialOrderTemplate,
  formatListOfAttachments,
  computeNewLines
}
